import { get, post } from '../http-calls';

export const getMABudgets_GetByAccountCode = async (accountCode) => {
    let res = await get(`MABudget/MABudgets_GetByAccountCode?AccountCode=${accountCode || ''}`, { useAuthToken: true });
    return res;
};

export const getMANominalAccount_UsedList = async (accountCode) => {
    let res = await get(`NominalCodes/MANominalAccount_UsedList?AccountCode=${accountCode || ''}`, { useAuthToken: true });
    return res;
};

export const postMABudgets_AddUpdate = async (data) => {
    let res = await post(`MABudget/MABudgets_AddUpdate`, data, { useAuthToken: true });
    return res;
};
export const postImportBudget = async (data) => {
    let res = await post(`MABudget/ImportBudget`, data, { useAuthToken: true });
    return res;
};
